/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { Library } from '../../Library';
import { AbstractCommand } from '../AbstractCommand';
import { LoggerCompat } from '../../compat/LoggerCompat';
import { NodeCompat } from '../../compat/NodeCompat';
import { Constants } from '../../core/Constants';
import { Document } from '../../core/models/Document';
import { NodePath } from '../../core/models/NodePath';
import { IServerParent } from '../../core/models/common/IServerParent';
import { Server } from '../../core/models/common/Server';

/**
 * A command used to delete a single server from an operation.
 * @author eric.wittmann@gmail.com
 * @extends AbstractCommand
 * @class
 */
export class DeleteServerCommand extends AbstractCommand {
    public _serverUrl : string;

    public _parentPath : NodePath;

    public _oldServer : any;

    public constructor(server? : any) {
        if(((server != null && server instanceof <any>Server) || server === null)) {
            let __args = arguments;
            super();
            if(this._serverUrl===undefined) this._serverUrl = null;
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._oldServer===undefined) this._oldServer = null;
            if(this._serverUrl===undefined) this._serverUrl = null;
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._oldServer===undefined) this._oldServer = null;
            (() => {
                this._serverUrl = server.url;
                this._parentPath = Library.createNodePath(server.parent());
            })();
        } else if(server === undefined) {
            let __args = arguments;
            super();
            if(this._serverUrl===undefined) this._serverUrl = null;
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._oldServer===undefined) this._oldServer = null;
            if(this._serverUrl===undefined) this._serverUrl = null;
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._oldServer===undefined) this._oldServer = null;
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#execute(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public execute(document : Document) {
        LoggerCompat.info("[DeleteServerCommand] Executing.");
        this._oldServer = null;
        let parent : IServerParent = <IServerParent><any>this._parentPath.resolve(document);
        if(this.isNullOrUndefined(parent)) {
            return;
        }
        let server : Server = parent.getServer(this._serverUrl);
        if(this.isNullOrUndefined(server)) {
            return;
        }
        let servers : Array<Server> = parent.getServers();
        /* remove */servers.splice(servers.indexOf(server), 1)[0];
        if(/* size */(<number>servers.length) === 0) {
            NodeCompat.setProperty(parent, Constants.PROP_SERVERS, null);
        }
        this._oldServer = Library.writeNode(server);
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#undo(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public undo(document : Document) {
        LoggerCompat.info("[DeleteServerCommand] Reverting.");
        if(this.isNullOrUndefined(this._oldServer)) {
            return;
        }
        let parent : IServerParent = <IServerParent><any>this._parentPath.resolve(document);
        if(this.isNullOrUndefined(parent)) {
            return;
        }
        let server : Server = parent.createServer();
        Library.readNode(this._oldServer, server);
        let servers : Array<Server> = parent.getServers();
        if(this.isNullOrUndefined(servers)) {
            servers = <any>([]);
            NodeCompat.setProperty(parent, Constants.PROP_SERVERS, servers);
        }
        /* add */(servers.push(server)>0);
    }
}
DeleteServerCommand["__class"] = "io.apicurio.datamodels.cmd.commands.DeleteServerCommand";
DeleteServerCommand["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];





import { MarshallCompat } from '../../compat/MarshallCompat';

